import React from 'react';
import { createPortal } from 'react-dom';
import clsx from 'clsx';
import { HtmlElementDefaults } from '../../type/HtmlElementDefaults';
import './XSMask.css';

type Input = HtmlElementDefaults & {
    unmount?: boolean;
};

export function XSMask(input: Input) {
    const { className, children, unmount, onClick } = input;

    // return createPortal(
    //     <div className={clsx('XSMask', className, { unmount })} onClick={onClick}>
    //         {children}
    //     </div>,
    //     document.body,
    // );

    return (
        <div className={clsx('XSMask', className, { unmount })} onClick={onClick}>
            {children}
        </div>
    );
}
